import React from 'react';
import type { IApiHandler } from './handlers';

export type ApiContextValue = {
    apiClient: IApiHandler;
    /**
     * The backend base URL ApiProvider was constructed with. Threaded into
     * the context so consumers that need to render server-relative paths
     * can resolve them against the bos-api host without re-reading
     * process.env.
     */
    baseUrl: string;
    getAccessToken?: () => string | null;
    removeAccessToken?: () => void;
};

export const ApiContext = React.createContext<ApiContextValue | undefined>(
    undefined,
);

export const useApi = (): ApiContextValue => {
    const context = React.useContext(ApiContext);
    if (!context) {
        throw new Error('useApi must be used within an ApiProvider');
    }
    return context;
};
